import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import shallowEqual from 'shallowequal';
import moment from 'moment';
import { getCybersourceConfig } from 'reducers/responseMetadata';
import {
  fingerPrintGenerated,
  deleteFingerprint,
} from 'reducers/payments/cybersource';
import WithApa from 'newComponents/WithApa/WithApa';
import Utils from '../../../../utils/Utils';
import { getHKS } from '../../../../utils/HKS';

const withFingerprint = WrappedComponent => {
  class CybersourceFingerprint extends React.PureComponent {
    static propTypes = {
      cyberSourceOptions: PropTypes.shape({}),
      onFingerPrintGenerated: PropTypes.func,
      onDeleteFingerprint: PropTypes.func,
      claroPaymentEnabled: PropTypes.bool,
    };

    state = { loading: null, fingerprint: '' };

    componentDidMount() {
      const { metadata } = this.props;
      const options = JSON.parse(
        _.get(metadata, 'cybersource_configuration', '{}'),
      );
      const { cyberSourceOptions, claroPaymentEnabled } = this.props;
      if (_.isEmpty(options) || !claroPaymentEnabled) return;

      this.setupCyberSource(options);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (
        !shallowEqual(
          nextProps.cyberSourceOptions,
          this.props.cyberSourceOptions,
        )
      ) {
        this.setupCyberSource(nextProps.cyberSourceOptions);
      }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return (
        !shallowEqual(nextProps, this.props) ||
        !shallowEqual(nextState, this.state)
      );
    }

    generateFigerprint = () => {
      const HKS = getHKS();
      const NOW = moment().format('HHmmss');
      return `${HKS}-${NOW}`;
    };

    setupCyberSource = options => {
      const region = window.utils.userType.checkRegion();
      const config = _.get(options, region);

      const ORG_ID = _.get(config, 'org_id');
      const MERCHANT_ID = _.get(config, 'merchant_id');
      const DOMAIN = _.get(config, 'custom_profiling_domain');

      const SESSION_ID = this.generateFigerprint();

      const script = document.createElement('script');

      script.setAttribute(
        'src',
        `${DOMAIN}?org_id=${ORG_ID}&session_id=${MERCHANT_ID}${SESSION_ID}`,
      );

      script.setAttribute('async', true);

      script.setAttribute('id', 'Gys5AWRKPC');

      script.onload = () => {
        this.setState({ loading: false, fingerprint: SESSION_ID }, () =>
          _.invoke(this.props, 'onFingerPrintGenerated', SESSION_ID),
        );
      };

      script.onerror = () => {
        this.setState({ loading: false });
      };

      document.body.appendChild(script);
    };

    componentWillUnmount() {
      // delete the script tag if exists
      const scriptElement = document.getElementById('Gys5AWRKPC');

      if (Utils.getDeviceOS() !== 'ie') {
        if (!document.contains(scriptElement)) return;
      } else if (!document.body.contains(scriptElement)) return;

      scriptElement.parentNode.removeChild(scriptElement);

      _.invoke(this.props, 'onDeleteFingerprint');
    }

    render() {
      const { claroPaymentEnabled } = this.props;
      if (!claroPaymentEnabled) return <WrappedComponent {...this.props} />;

      // heads up

      const { loading, fingerprint } = this.state;
      if (loading) return null;

      return <WrappedComponent {...this.props} fingerprint={fingerprint} />;
    }
  }

  hoistNonReactStatics(CybersourceFingerprint, WrappedComponent);

  const mapStateToProps = state => ({
    cyberSourceOptions: getCybersourceConfig(state),
  });

  const mapDispatchToProps = dispatch => ({
    onFingerPrintGenerated: payload => dispatch(fingerPrintGenerated(payload)),
    onDeleteFingerprint: () => dispatch(deleteFingerprint()),
  });

  const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
  );
  return compose(
    WithApa,
    withConnect,
  )(CybersourceFingerprint);
};

export default withFingerprint;
